import React, { useState, useRef } from 'react';
import Tesseract from 'tesseract.js';
import { Jimp, JimpMime } from 'jimp';
import Webcam from 'react-webcam';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { Button, Stack, Typography } from '@mui/joy';
import '../../styles/cardScan.css';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { handleError } from '../../utils/error-handling';
import api from '../../api/apiClient';

export default function CardScan({ setNextPage }) {
  const webcamRef = useRef(null);
  const canvasRef = useRef(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [capturedImage, setCapturedImage] = useState(null);
  // const [textImage, setTextImage] = useState(null);
  // const [textx, setTextx] = useState(null);

  const handleCapture = async () => {
    setIsProcessing(true);

    if (!webcamRef.current) return;
    try {
      const dataURL = webcamRef.current.getScreenshot();
      setCapturedImage(dataURL);

      const img = await Jimp.read(dataURL);

      const originalImg = img.clone();
      // img.flip({ horizontal: true });
      // img.contrast(0.5);
      // img.brightness(1.5);

      // Get the dimensions of the webcam view
      const imgWidth = img.width;
      const imgHeight = img.height;

      // Calculate the center position for cropping
      const cropX = Math.floor((imgWidth - 300) / 2);
      const cropY = Math.floor((imgHeight - 190) / 2);

      img.crop({ x: cropX, y: cropY, w: 300, h: 190 });
      const base64Image = await img.getBase64(JimpMime.png);
      const originalBuffer = await originalImg.getBuffer(JimpMime.png);

      // setTextImage(base64Image);
      const {
        data: { text },
      } = await Tesseract.recognize(base64Image, 'eng');

      // remove all non digit or new lines characters

      const cardPattern = /(\b\d{4}[-\s]?\d{4}[-\s]?\d{4}[-\s]?\d{4}\b)/g;
      const matches = text.match(cardPattern);

      const formData = new FormData();
      formData.append(
        'cardImage',
        new File([originalBuffer], 'card.jpg', { type: 'image/jpeg' })
      );

      if (matches && matches.length > 0) {
        // setTextx(matches[0]);
        formData.append('cardNumber', matches[0]);
      }
      const response = await api.post('/card/photo', formData);
      if (response.data.success) {
        setNextPage({ route: '/pin' });
      } else {
        navigate('/card-digits');
      }
    } catch (err) {
      handleError('error', err.message);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleRetake = () => {
    setCapturedImage(null);
  };

  return (
    <div className="flex flex-col items-center justify-center pb-10 mb-10">
      <Stack spacing={2}>
        <Typography variant="h2" fontSize={20} className="text-center">
          {t('cardScanPage.title')}
        </Typography>
        <Typography variant="body1" className="text-center">
          {t('cardScanPage.instructions')}
        </Typography>

        <div className="camera-container flex justify-center items-center px-4">
          {capturedImage ? (
            <img
              src={capturedImage}
              alt="Captured card"
              className="w-full object-cover"
            />
          ) : (
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={{
                facingMode: 'environment',
              }}
              forceScreenshotSourceSize
              className="w-full object-cover"
            />
          )}

          {/* The masked overlay. 
            In CSS, you’ll position this overlay such that only the "card" area is transparent. */}
          <div className="overlay-mask">
            <div className="card-window">
              <div></div>
              <div className="corner-marker top-left"></div>
              <div className="corner-marker top-right"></div>
              <div className="corner-marker bottom-left"></div>
              <div className="corner-marker bottom-right"></div>
            </div>
          </div>
        </div>

        {/* Canvas used to capture the screenshot */}
        <canvas ref={canvasRef} style={{ display: 'none' }} />

        <div className="flex justify-center items-center">
          {capturedImage ? (
            <Button
              variant="soft"
              onClick={handleRetake}
              disabled={isProcessing}
            >
              {t('cardScanPage.retake')}
            </Button>
          ) : (
            <Button
              startDecorator={<PhotoCameraIcon />}
              variant="soft"
              onClick={handleCapture}
              disabled={isProcessing}
              loading={isProcessing}
            >
              {t('cardScanPage.capture')}
            </Button>
          )}
        </div>
      </Stack>
      {/* {capturedImage && (
        <>
          <img src={textImage} alt="text" />
          <br />
          {textx}
        </>
      )} */}
    </div>
  );
}
